import { styled } from '@mui/material';
import { Box } from 'ui';

export const Main = styled(Box)(({ theme }) => ({
  width: theme.spacing(52),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

export default Main;
